export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-grid-select/index.js